exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "slot {\r\n    display: flex !important;\r\n    align-items: stretch;\r\n    justify-content: stretch;\r\n    min-height: 9rem;\r\n}\r\n\r\nslot > * {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\nslot .segment {\r\n    min-height: 0 !important;\r\n    height: 100%;\r\n}", ""]);

